import React from 'react';
import { Settings, Link } from 'lucide-react';
import { useNavigate } from "react-router-dom";
const VisionSection = () => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/contactus"); // This navigates to the demo page
  };
  return (
    <div className="vision-section">
      <h1 className="main-heading">WAREHOUSE MANAGEMENT SYSTEM</h1>
      
      <div className="content-container">
        <div className="left-content">
          <p className="description">
            Transform your warehouse operations with our cutting-edge management system. 
            We empower businesses with intelligent solutions that drive efficiency, 
            accuracy, and growth in the modern supply chain landscape.
          </p>

          <div className="features-container">
            <div className="feature">
              <div className="icon-box">
                <Settings size={20} />
              </div>
              <div className="feature-content">
                <h3>ADVANCED WMS SOLUTIONS</h3>
                <p>
                  Leverage our state-of-the-art Warehouse Management System to streamline 
                  operations, reduce costs, and maximize productivity.
                </p>
              </div>
            </div>

            <div className="feature">
              <div className="icon-box">
                <Link size={20} />
              </div>
              <div className="feature-content">
                <h3>ENTERPRISE INTEGRATION</h3>
                <p>
                  Seamlessly connect with your existing enterprise systems including ERP, 
                  OMS, and transportation management platforms.
                </p>
              </div>
            </div>
          </div>

          <div className="button-container">
          <button className="cta-button" onClick={handleClick}>
      SCHEDULE A DEMO <span> </span>
    </button>
          </div>
        </div>

        <div className="right-content">
          <div className="image-grid">
            <div className="main-image">
              <img src="/wms1.jpg" alt="Warehouse Operations" />
            </div>
            <div className="small-images">
              <div className="small-image">
                <img src="/wms2.png" alt="Inventory Management" className="focus-top" />
              </div>
              <div className="small-image overlay-container">
                <img src="/wms6.png" alt="Technology Integration" className="focus-bottom" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        /* Base styles and CSS Reset */
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        /* Root section styles */
        .vision-section {
          min-height: 100vh;
          background-color: white;
          width: 100%;
          padding: clamp(1rem, 3vw, 2rem);
          margin: 0 auto;
          display: flex;
          flex-direction: column;
          font-family: Oswald, sans-serif;
          max-width: min(95vw, 1400px);
        }

        /* Heading styles */
        .main-heading {
          font-size: 50px;
          line-height: 40px;
          font-family: Oswald, sans-serif;
          text-align: center;
          font-size: clamp(1.5rem, 4vw, 2.5rem);
          color: #410684;
          margin-bottom: 10px;
          font-weight: 600;
          position: relative;
          letter-spacing: 0.05em;
          padding-bottom: 1rem;
        }

        /* Content container */
        .content-container {
          display: flex;
          gap: clamp(1rem, 4vw, 2.5rem);
          align-items: center;
          flex: 1;
          padding: clamp(0.5rem, 2vw, 1.5rem);
          flex-wrap: wrap;
        }

        /* Left content section */
        .left-content {
          flex: 1;
          min-width: min(100%, 500px);
          flex-basis: 45%;
        }

        .description {
          font-size: 16px;
          line-height: 24px;
          color: #414042;
          font-weight: 400;
          font-family: Inter, sans-serif;
          margin-bottom: clamp(1rem, 3vw, 1.5rem);
        }

        /* Features section */
        .features-container {
          display: flex;
          flex-direction: column;
          gap: clamp(0.75rem, 2vw, 1.25rem);
          margin-bottom: clamp(1rem, 3vw, 1.5rem);
        }

        .feature {
          display: flex;
          gap: clamp(0.5rem, 2vw, 1rem);
          padding: clamp(0.75rem, 2vw, 1rem);
          background: #ffffff;
          border-radius: 8px;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
          transition: transform 0.3s ease;
        }

        .feature:hover {
          transform: translateY(-3px);
        }

        .icon-box {
          width: clamp(2rem, 5vw, 2.5rem);
          height: clamp(2rem, 5vw, 2.5rem);
          background: linear-gradient(135deg, #f0f4ff, #e8eaf6);
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #410684;
          flex-shrink: 0;
        }

        .feature-content h3 {
          color: #410684;
          font-size: 20px;
          line-height: 32px;
          margin-bottom: 0.5rem;
          font-weight: 700;
        }

        .feature-content p {
          color: #414042;
          font-weight: 400;
          font-family: Inter, sans-serif;
          font-size: 14px;
          line-height: 20px;
        }

        /* Button Container */
        .button-container {
          display: flex;
          justify-content: flex-start;
          margin-top: 1rem;
        }

        /* CTA Button */
        .cta-button {
          background-color: #410684;
          color: white;
          padding: 0.85rem 2rem;
          border-radius: 4px;
          font-family: Oswald, sans-serif;
          border: none;
          font-size: 18px;
          line-height: 20px;
          font-weight: 500;
          cursor: pointer;
          text-decoration: none;
          width: 200px;
          text-align: center;
          transition: all 0.3s ease;
        }

        .cta-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 15px rgba(65, 6, 132, 0.2);
        }

        /* Right content section */
        .right-content {
          flex: 1;
          flex-basis: 45%;
          min-width: min(100%, 500px);
        }

        .image-grid {
          display: flex;
          flex-direction: column;
          gap: clamp(0.5rem, 2vw, 1rem);
        }

        .main-image {
          width: 100%;
          height: clamp(150px, 30vw, 250px);
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
        }

        .small-images {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: clamp(0.5rem, 2vw, 1rem);
        }

        .small-image {
          height: clamp(100px, 20vw, 150px);
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
        }

        .small-images .overlay-container {
          position: relative;
        }

        .small-images .overlay-container::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.15);
          border-radius: 10px;
          pointer-events: none;
        }
          
        .small-images .focus-top {
          object-fit: cover;
          object-position: top;
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s ease;
        }

        img:hover {
          transform: scale(1.05);
        }

        /* Responsive breakpoints */
        @media (max-width: 1200px) {
          .content-container {
            gap: 2rem;
          }
        }

        @media (max-width: 992px) {
          .vision-section {
            padding: 1rem;
          }
          
          .content-container {
            flex-direction: column;
            gap: 2rem;
          }

          .left-content,
          .right-content {
            min-width: 100%;
          }
        }

        @media (max-width: 768px) {
          .main-heading {
            font-size: 28px;
          }

          .feature {
            padding: 1rem;
          }

          .main-image {
            height: 200px;
          }

          .small-image {
            height: 120px;
          }
        }

        @media (max-width: 480px) {
          .vision-section {
            padding: 0.75rem;
          }

          .main-heading {
            font-size: 28px;
          }

          .feature {
            flex-direction: column;
            align-items: center;
            text-align: center;
          }

          .icon-box {
            margin-bottom: 0.5rem;
          }

          .main-image {
            height: 180px;
          }

          .small-image {
            height: 100px;
          }

          .button-container {
            justify-content: center;
          }
        }

        /* Print styles */
        @media print {
          .vision-section {
            height: auto;
            padding: 1cm;
          }

          .feature:hover {
            transform: none;
          }

          img:hover {
            transform: none;
          }

          .cta-button {
            display: none;
          }
        }
      `}</style>
    </div>
  );
};

export default VisionSection;